@if (moveableBookFeature && !moveableBookFeature.isDeleted && !isRect) {
    <div
            [ngStyle]="{
     'top.%': moveableBookFeature.position.y,
     'left.%': moveableBookFeature.position.x,
     'height.%': moveableBookFeature.position.h || 2,
     'width.%': moveableBookFeature.position.w || 5,
     'z-index': moveableBookFeature.zIndex
     }" class="page-book-feature">
        <ng-container #childHost />
    </div>
}

@if (moveableBookFeature && !moveableBookFeature.isDeleted && isRect) {
    <div
            [ngStyle]="{
     'top.%': moveableBookFeature.position.y,
     'left.%': moveableBookFeature.position.x,
     'z-index': moveableBookFeature.zIndex
     }" class="page-book-feature">
        <ng-container #childHost />
    </div>
}

